import { docs, marketing, blog, feature, audience } from "./collections";
import type { ContentPageData } from "./server";
import { getContentPage } from "./loaders";
import { seoHead } from "@/lib/seo";
import { SHARE_SIZE } from "./article";

export async function loadContentPage(slugs: string[]) {
  const data = await getContentPage(slugs);
  await { docs, marketing, blog, feature, audience }[data.collection].getPage(data.path)?.preload();
  return data;
}

export function contentHead(data?: ContentPageData) {
  if (!data) return {};
  const head = seoHead({
    title: data.seoTitle,
    description: data.seoDescription,
    path: data.url,
    keywords: data.keywords,
    image: data.image,
    type: data.blog || data.article ? "article" : "website",
    publishedTime: data.article?.datePublished ?? data.blog?.datePublished,
    modifiedTime: data.article?.dateModified ?? data.blog?.dateModified,
  });
  if (!data.article) return head;
  // An article's share image is its cover, at the size social sites ask for.
  return {
    ...head,
    meta: [
      ...head.meta,
      { property: "og:image:width", content: String(SHARE_SIZE.width) },
      { property: "og:image:height", content: String(SHARE_SIZE.height) },
      { property: "og:image:alt", content: data.title },
    ],
  };
}
